import { EditModule, type EditSettings, FilterModule, Grid, PagerModule} from "@syncfusion/react-grid";


import { useEffect, useState, type ReactNode } from "react";
import type { DataSource } from "../../services/data-source";


export interface ApiGridOptions<T extends {id: string}> {
    dataSource: DataSource<T>
    children: ReactNode
}

const modules = { EditModule, FilterModule, PagerModule };

export function ApiGrid<T extends {id: string}>(opts: ApiGridOptions<T>): ReactNode {

    
    const [toolbar] = useState<string[]>(["Add", "Edit", "Delete", "Update", "Cancel"]);
    const [editSettings] = useState<EditSettings>({mode:'Normal', allowEdit: true, allowAdd: true, allowDelete: true});

    const dataSource = opts.dataSource;

    useEffect(() => {
        dataSource.get()
    }, []);


    return (
        <div>
            <Grid height={500}
            toolbar={toolbar}
            dataSource={dataSource.data}
            modules={modules} 
            onDataRequest={()=>dataSource.get()}
            onDataChangeStart={dataSource.dataChangeStart}
            pageSettings={dataSource.pageSettings}
            editSettings={editSettings}
            >
                {opts.children}
            </Grid>
        </div>
    );
};